// Refer to : https://material-ui.com/customization/default-theme/
import { createTheme, Theme as MaterialUITheme } from '@material-ui/core';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#242D45',
      light: '#2485f6',
      dark: '#242D45',
    },
  //   secondary: {
  //     main: '#0091ae',
  //     light: '#cbd6e2',
  //     dark: '#242D45',
  //   },
  //   background: {
  //     default: '#FFFFFF',
  //     paper: '#ffffff',
  //   },
  //   warning: {
  //     main: '#EF6B6B',
  //     contrastText: '#fff',
  //   },
  //   info: {
  //     main: '#fff',
  //     contrastText: '#707070',
  //   },
  },
  typography: {
    fontFamily: `'Raleway', sans-serif`,
  },
});

export type Theme = MaterialUITheme;
export default theme;
